<template>
  <div class="recruit-detail">
    <!-- Hero -->
    <section class="recruit-detail-hero">
      <div class="recruit-detail-hero-bg">
        <img src="/static/lx.png" alt="招贤纳士">
      </div>
      <div class="recruit-detail-hero-content">
        <div class="hero-bar"></div>
        <h1>招贤纳士</h1>
        <p class="hero-en">RECRUIT</p>
      </div>
    </section>

    <!-- Tab -->
    <section class="recruit-detail-tab-section">
      <div class="container">
        <div class="contact-tabs">
          <div
            class="contact-tab-item"
            :class="{ active: false }"
            @click="$router.push('/contact')"
          >
            联系方式
          </div>
          <div class="contact-tab-divider"></div>
          <div class="contact-tab-item active">
            招贤纳士
          </div>
        </div>
      </div>
    </section>

    <!-- 详情内容 -->
    <section v-if="currentJob" class="recruit-detail-main">
      <div class="container">
        <!-- 职位头部卡片 -->
        <div class="job-header-card" data-aos="fade-up">
          <div class="job-header-top">
            <div class="job-header-left">
              <h2 class="job-header-title">{{ currentJob.title }}</h2>
              <div class="job-header-sub">
                性别：{{ currentJob.gender }} / 年龄：{{ currentJob.age }} / {{ currentJob.education }} / 招聘人数：{{ currentJob.count }}人
              </div>
            </div>
            <div class="job-header-right">
              <div class="job-location">
                <i class="el-icon-map-location"></i>
                {{ currentJob.location }}
              </div>
              <div class="job-date">
                <i class="el-icon-time"></i>
                {{ currentJob.date }}
              </div>
            </div>
          </div>
        </div>

        <!-- 岗位职责 -->
        <div class="detail-block" data-aos="fade-up">
          <h3 class="detail-block-title">岗位职责：</h3>
          <ol class="detail-list">
            <li v-for="(item, idx) in currentJob.responsibilities" :key="idx">{{ item }}</li>
          </ol>
        </div>

        <!-- 任职资格 -->
        <div class="detail-block" data-aos="fade-up">
          <h3 class="detail-block-title">任职资格：</h3>
          <ol class="detail-list">
            <li v-for="(item, idx) in currentJob.qualifications" :key="idx">{{ item }}</li>
          </ol>
        </div>

        <!-- 联系方式 -->
        <div class="detail-block contact-block" data-aos="fade-up">
          <p>有意者发送简历至 {{ currentJob.email }}</p>
          <p>或拨打电话：{{ currentJob.phone }}</p>
        </div>

        <!-- 返回按钮 -->
        <div class="detail-back" data-aos="fade-up">
          <button class="btn-back" @click="goBack">
            <i class="el-icon-back"></i>
            返回
          </button>
        </div>
      </div>
    </section>

    <!-- 未找到 -->
    <section v-else class="recruit-detail-main">
      <div class="container">
        <div class="not-found">
          <i class="el-icon-warning-outline"></i>
          <p>未找到对应的职位信息</p>
          <button class="btn-back" @click="goBack">
            <i class="el-icon-back"></i>
            返回列表
          </button>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
// 所有职位数据（与 Contact.vue 保持一致，这里补充详情字段）
const ALL_JOBS = [
  {
    id: 1, title: '市场开发部经理', location: '深圳', education: '不限/本科', count: 2, date: '2036年5月26日',
    gender: '不限', age: '不限', email: '403501358@qq.com', phone: '0371-56972228',
    responsibilities: [
      '负责市场开发与客户关系维护，制定并实施市场开拓计划；',
      '组织市场调研，分析行业动态与竞争对手情况，为公司决策提供支持；',
      '负责重点客户对接与项目洽谈，推动项目落地；',
      '管理市场团队，统筹市场推广、品牌宣传等工作；',
      '完成公司下达的市场开发目标与业绩指标。'
    ],
    qualifications: [
      '本科及以上学历，市场营销、工商管理等相关专业；',
      '5年以上市场开发或相关管理经验，有咨询行业经验者优先；',
      '具备良好的沟通表达能力与商务谈判能力；',
      '有较强的市场洞察力和数据分析能力；',
      '能适应出差，具备团队合作精神。'
    ]
  },
  {
    id: 2, title: '人力资源部经理', location: '深圳', education: '不限/本科', count: 2, date: '2036年5月26日',
    gender: '不限', age: '不限', email: '403501358@qq.com', phone: '0371-56972228',
    responsibilities: [
      '全面负责公司人力资源管理工作，制定并执行人力资源战略规划；',
      '建立和完善招聘、培训、绩效考核、薪酬福利等各项HR制度；',
      '组织开展人才招聘，做好人才储备与梯队建设；',
      '负责员工关系管理，协调解决员工劳动纠纷；',
      '推动企业文化建设，提升员工凝聚力和归属感。'
    ],
    qualifications: [
      '本科及以上学历，人力资源管理相关专业；',
      '5年以上人力资源管理经验，有同行业经验者优先；',
      '熟悉国家劳动法律法规及人力资源相关政策；',
      '具备良好的沟通协调能力与组织管理能力；',
      '有较强的责任心，为人正直，执行力强。'
    ]
  },
  {
    id: 3, title: '标书制作专员', location: '深圳', education: '不限/本科', count: 2, date: '2036年5月26日',
    gender: '不限', age: '不限', email: '403501358@qq.com', phone: '0371-56972228',
    responsibilities: [
      '负责项目投标文件的编制、排版、审核；',
      '整理公司资质、业绩、人员等相关投标资料；',
      '根据招标文件要求，撰写投标方案与技术标内容；',
      '协助投标团队进行投标前的评审与修改；',
      '负责投标书的装订、密封及投标现场的文件提交。'
    ],
    qualifications: [
      '大专及以上学历，工程管理、商务、文秘等相关专业；',
      '1年以上标书制作经验，有工程咨询行业经验者优先；',
      '熟悉招投标法律法规及投标流程；',
      '熟练使用 Word、Excel、PPT 等办公软件；',
      '工作细心严谨，有较强的责任心。'
    ]
  },
  {
    id: 4, title: '监理员', location: '深圳', education: '不限/本科', count: 2, date: '2036年5月26日',
    gender: '不限', age: '不限', email: '403501358@qq.com', phone: '0371-56972228',
    responsibilities: [
      '协助专业监理工程师开展施工现场监理工作；',
      '负责进场材料、设备的检查与验收；',
      '做好监理日志、旁站记录等日常监理工作；',
      '配合总监组织工程例会，协调施工中的问题；',
      '参与工程竣工验收，整理监理资料。'
    ],
    qualifications: [
      '大专及以上学历，土木工程、工程监理等相关专业；',
      '持有监理员证书优先；',
      '熟悉建筑工程施工规范及验收标准；',
      '工作认真负责，能吃苦耐劳；',
      '能适应工程现场工作环境。'
    ]
  },
  {
    id: 5, title: '住建部注册监理工程师', location: '深圳', education: '不限/本科', count: 2, date: '2036年5月26日',
    gender: '不限', age: '不限', email: '403501358@qq.com', phone: '0371-56972228',
    responsibilities: [
      '负责住建部监管工程项目的监理工作；',
      '审查施工组织设计、专项方案，提出监理意见；',
      '组织工程预检、隐蔽工程验收、分项分部工程验收；',
      '处理工程质量、安全问题，下达监理指令；',
      '协调建设、施工、设计各方关系，推动工程顺利进行。'
    ],
    qualifications: [
      '本科及以上学历，土木工程、工程管理相关专业；',
      '持有住建部注册监理工程师资格证书；',
      '3年以上房屋建筑工程监理经验；',
      '熟悉现行国家及地方建设工程规范标准；',
      '具备良好的沟通协调能力和团队管理能力。'
    ]
  },
  {
    id: 6, title: '水利部注册监理工程师', location: '深圳', education: '不限/本科', count: 2, date: '2036年5月26日',
    gender: '不限', age: '不限', email: '403501358@qq.com', phone: '0371-56972228',
    responsibilities: [
      '负责水利水电工程项目的监理工作；',
      '审查施工单位资质、施工组织设计及专项施工方案；',
      '组织水利工程质量检查与验收；',
      '处理水利工程施工中的技术、质量、安全问题；',
      '协调各方关系，保障工程按计划推进。'
    ],
    qualifications: [
      '本科及以上学历，水利水电工程相关专业；',
      '持有水利部注册监理工程师资格证书；',
      '3年以上水利工程监理经验；',
      '熟悉水利工程设计、施工、验收规范；',
      '工作严谨认真，责任心强。'
    ]
  },
  {
    id: 7, title: '交通部注册监理工程师', location: '深圳', education: '不限/本科', count: 2, date: '2036年5月26日',
    gender: '不限', age: '不限', email: '403501358@qq.com', phone: '0371-56972228',
    responsibilities: [
      '负责公路、水运等交通工程项目的监理工作；',
      '审查交通工程施工方案及专项安全方案；',
      '组织路基、路面、桥涵等分项工程验收；',
      '处理交通工程施工中的质量、安全问题；',
      '协调参建各方，推进工程顺利实施。'
    ],
    qualifications: [
      '本科及以上学历，公路工程、交通运输相关专业；',
      '持有交通部注册监理工程师资格证书；',
      '3年以上交通工程监理经验；',
      '熟悉交通工程技术标准和施工规范；',
      '具备团队管理和协调能力。'
    ]
  },
  {
    id: 8, title: '注册造价工程师（安装专业）', location: '深圳', education: '不限/本科', count: 2, date: '2036年5月26日',
    gender: '不限', age: '不限', email: '403501358@qq.com', phone: '0371-56972228',
    responsibilities: [
      '负责机电安装、给排水、电气等安装专业造价咨询工作；',
      '编制和审核安装工程概算、预算、结算、决算；',
      '参与项目招投标工作，编制安装工程招标控制价与投标报价；',
      '实施全过程造价控制，分析造价偏差原因并提出调整建议；',
      '配合完成安装工程的合同管理与造价谈判。'
    ],
    qualifications: [
      '本科及以上学历，安装工程、机电工程相关专业；',
      '持有注册造价工程师资格证书；',
      '3年以上安装专业造价工作经验；',
      '熟悉安装工程定额、计价规范与造价软件；',
      '工作细致，具备较强的责任心。'
    ]
  },
  {
    id: 9, title: '注册造价工程师（水利专业）', location: '深圳', education: '不限/本科', count: 2, date: '2036年5月26日',
    gender: '不限', age: '不限', email: '403501358@qq.com', phone: '0371-56972228',
    responsibilities: [
      '负责水利水电工程项目的造价咨询工作；',
      '编制和审核水利工程概算、预算、结算、决算；',
      '参与水利工程招投标，编制招标控制价与投标报价；',
      '实施水利工程全过程造价管理与控制；',
      '配合合同签订、变更处理及索赔审核。'
    ],
    qualifications: [
      '本科及以上学历，水利水电工程相关专业；',
      '持有注册造价工程师资格证书；',
      '3年以上水利工程造价工作经验；',
      '熟悉水利工程定额、计价规范；',
      '具备良好的沟通能力与团队协作精神。'
    ]
  },
  {
    id: 10, title: '注册造价工程师（公路运输专业）', location: '深圳', education: '不限/本科', count: 2, date: '2036年5月26日',
    gender: '不限', age: '不限', email: '403501358@qq.com', phone: '0371-56972228',
    responsibilities: [
      '负责公路、桥梁、隧道等交通工程项目的造价咨询工作；',
      '编制和审核公路工程概算、预算、结算、决算；',
      '参与公路工程招投标，编制招标控制价与投标报价；',
      '实施公路工程全过程造价管理与控制；',
      '配合合同谈判、变更及索赔处理。'
    ],
    qualifications: [
      '本科及以上学历，公路工程、交通运输相关专业；',
      '持有注册造价工程师资格证书；',
      '3年以上公路工程造价工作经验；',
      '熟悉公路工程定额、计价规范与造价软件；',
      '工作严谨认真，具备良好的团队协作能力。'
    ]
  },
  {
    id: 11, title: '注册安全工程师', location: '深圳', education: '不限/大专', count: 2, date: '2036年5月26日',
    gender: '不限', age: '不限', email: '403501358@qq.com', phone: '0371-56972228',
    responsibilities: [
      '贯彻执行安全生产方针政策、法律法规、标准和本办法，并对执行情况进行监督检查；',
      '制定安全生产工作计划和方针目标，并督导实施；',
      '掌握安全动态，制定或修改安全生产综合管理制度和操作规程执行情况进行监督检查；',
      '协助领导组织推动安全生产活动，宣传安全生产法规，提高全体员工的安全生产意识；',
      '建立定期安全检查制度，组织开展安全生产检查活动，发现重大事故隐患或违章指挥、违章作业或遇有重大险情时，必须采取有效措施，并责令有关单位处理；',
      '参加施工组织设计（或施工方案）的会审，并对安全技术措施的执行情况进行监督检查；',
      '参加施工生产例会，掌握施工生产信息，预测事故发生的可能性，提出防范建议，参加新建、改建、扩建工程"三同时"项目的设计、审查和竣工验收；',
      '组织开展《安全标准工地》创建工作，负责《安全标准工地》的考评工作；',
      '组织开展安全宣传和评比活动，推广先进经验；',
      '制定公司员工劳动防护用品、保健食品、防暑降温及劳动护肤用品的管理办法和发放标准，并组织实施；',
      '组织生产安全事故的调查处理，进行事故统计、分析、定性、定责和上报，对各单位执行事故报告处理制度的情况进行监督检查；',
      '负责职业健康安全相关信息的分析，并提出改进建议和要求；',
      '接受和配合职业健康突发事件和安全事故调查处理，落实和监督检查事故处置方案的实施情况；',
      '完成领导交办的其他工作。'
    ],
    qualifications: [
      '大学专科及以上学历，建筑、土木、工民建类相关专业；',
      '有注册安全工程师相关证书者优先；',
      '具有较强的沟通能力和组织协调能力，能够合理、有效地协调各项相关工作，工作严谨、认真、细致，具备一定的计算机操作能力；',
      '责任心强、吃苦耐劳。'
    ]
  },
  {
    id: 12, title: '注册一级结构工程师', location: '深圳', education: '不限/本科', count: 2, date: '2036年5月26日',
    gender: '不限', age: '不限', email: '403501358@qq.com', phone: '0371-56972228',
    responsibilities: [
      '负责建筑结构方案设计与施工图设计；',
      '进行结构计算分析，确保结构安全经济合理；',
      '审核图纸，解决施工中的结构技术问题；',
      '配合建筑、机电等专业做好各专业协调；',
      '参与项目结构相关的技术评审与论证。'
    ],
    qualifications: [
      '本科及以上学历，土木工程、结构工程相关专业；',
      '持有一级注册结构工程师资格证书；',
      '5年以上建筑结构设计经验；',
      '熟练使用 PKPM、YJK、MIDAS 等结构设计软件；',
      '具备良好的沟通协作能力，工作严谨认真。'
    ]
  },
  {
    id: 13, title: '高级工程师', location: '郑州', education: '本科', count: 3, date: '2036年5月26日',
    gender: '不限', age: '不限', email: '403501358@qq.com', phone: '0371-56972228',
    responsibilities: [
      '负责工程咨询项目的技术把关与方案审核；',
      '独立承担大型项目的技术负责人角色；',
      '指导初级工程师开展技术工作，做好传帮带；',
      '跟踪行业技术前沿，推动公司技术创新与进步；',
      '参与公司技术标准、规范的制定与修订。'
    ],
    qualifications: [
      '本科及以上学历，工程类相关专业；',
      '持有高级工程师职称或注册执业资格证书；',
      '10年以上相关工作经验，有大型项目负责经验；',
      '在专业领域有较高的技术造诣，发表过相关论文者优先；',
      '具备良好的团队管理和沟通协调能力。'
    ]
  },
  {
    id: 14, title: '注册咨询工程师（投资）', location: '郑州', education: '本科', count: 2, date: '2036年5月26日',
    gender: '不限', age: '不限', email: '403501358@qq.com', phone: '0371-56972228',
    responsibilities: [
      '负责项目建议书、可行性研究报告的编制与审核；',
      '开展项目投资估算、融资方案分析及财务评价；',
      '参与规划咨询、政策研究等业务；',
      '负责项目后评价、专项咨询等工作；',
      '配合市场开拓，参与项目投标与合同谈判。'
    ],
    qualifications: [
      '本科及以上学历，工程技术、经济管理相关专业；',
      '持有注册咨询工程师（投资）资格证书；',
      '3年以上工程咨询或投资咨询工作经验；',
      '熟悉国家产业政策、投资政策及相关法规；',
      '具备良好的文字表达和分析能力。'
    ]
  },
  {
    id: 15, title: '项目经理', location: '深圳', education: '不限/本科', count: 2, date: '2036年5月26日',
    gender: '不限', age: '不限', email: '403501358@qq.com', phone: '0371-56972228',
    responsibilities: [
      '全面负责工程项目的组织实施与管理；',
      '制定项目计划，统筹项目进度、质量、成本、安全管理；',
      '协调公司内部各部门及项目参建各方关系；',
      '管理项目团队，做好团队建设与绩效考核；',
      '负责项目结算、回款及后续服务工作。'
    ],
    qualifications: [
      '本科及以上学历，工程管理、建筑工程相关专业；',
      '5年以上工程项目管理经验，PMP/一级建造师证书优先；',
      '熟悉工程项目管理流程及相关法律法规；',
      '具备优秀的沟通协调能力和团队管理能力；',
      '工作责任心强，能承担较大工作压力。'
    ]
  }
]

export default {
  name: 'RecruitDetail',
  data() {
    return {
      allJobs: ALL_JOBS
    }
  },
  computed: {
    currentJob() {
      const id = parseInt(this.$route.params.id, 10)
      return this.allJobs.find(j => j.id === id)
    }
  },
  methods: {
    goBack() {
      // 有历史就返回，没有就回列表
      if (window.history.length > 1) {
        this.$router.back()
      } else {
        this.$router.push({ path: '/contact', query: { tab: 'recruit' } })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
/* ===== Hero ===== */
.recruit-detail-hero {
  position: relative;
  height: 320px;
  overflow: hidden;
}

.recruit-detail-hero-bg {
  position: absolute;
  inset: 0;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

.recruit-detail-hero-content {
  position: relative;
  z-index: 2;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-left: 120px;
  color: #fff;
}

.hero-bar {
  width: 60px;
  height: 4px;
  background: #c8102e;
  margin-bottom: 24px;
}

.recruit-detail-hero-content h1 {
  font-size: 44px;
  font-weight: 700;
  margin: 0 0 12px;
  letter-spacing: 2px;
}

.hero-en {
  font-size: 16px;
  letter-spacing: 4px;
  opacity: 0.85;
  margin: 0;
}

/* ===== Tab ===== */
.recruit-detail-tab-section {
  background: #fff;
  border-bottom: 1px solid #eee;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.contact-tabs {
  display: flex;
  align-items: center;
  gap: 40px;
  padding: 18px 0;
}

.contact-tab-item {
  font-size: 15px;
  color: #333;
  cursor: pointer;
  padding: 6px 0;
  position: relative;
  transition: color 0.25s;
  user-select: none;

  &:hover {
    color: #c8102e;
  }

  &.active {
    color: #c8102e;
    font-weight: 600;
  }

  &.active::after {
    content: '';
    position: absolute;
    bottom: -12px;
    left: 0;
    width: 100%;
    height: 2px;
    background: #c8102e;
  }
}

.contact-tab-divider {
  width: 1px;
  height: 14px;
  background: #ddd;
}

/* ===== 主内容 ===== */
.recruit-detail-main {
  padding: 60px 0 80px;
  background: #fff;
}

/* 职位头部卡片 */
.job-header-card {
  padding-bottom: 30px;
  border-bottom: 1px solid #eee;
  margin-bottom: 40px;
}

.job-header-top {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 40px;
}

.job-header-left {
  flex: 1;
}

.job-header-title {
  font-size: 24px;
  font-weight: 600;
  color: #222;
  margin: 0 0 14px;
}

.job-header-sub {
  font-size: 13px;
  color: #666;
}

.job-header-right {
  text-align: right;
  flex-shrink: 0;
}

.job-location {
  font-size: 14px;
  color: #888;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 4px;
  margin-bottom: 10px;

  i {
    font-size: 16px;
  }
}

.job-date {
  font-size: 13px;
  color: #999;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 4px;
}

/* 详情块 */
.detail-block {
  margin-bottom: 36px;
}

.detail-block-title {
  font-size: 15px;
  font-weight: 600;
  color: #222;
  margin: 0 0 16px;
}

.detail-list {
  padding-left: 22px;
  margin: 0;
  counter-reset: li;

  li {
    font-size: 14px;
    color: #444;
    line-height: 2;
  }
}

/* 联系方式 */
.contact-block {
  margin-top: 40px;
  padding: 24px;
  background: #fafafa;
  border-radius: 4px;

  p {
    font-size: 14px;
    color: #444;
    margin: 6px 0;
  }
}

/* 返回按钮 */
.detail-back {
  margin-top: 50px;
  padding-top: 30px;
  border-top: 1px solid #eee;
}

.btn-back {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 10px 24px;
  border: 1px solid #ddd;
  background: #fff;
  color: #666;
  font-size: 14px;
  cursor: pointer;
  border-radius: 2px;
  transition: all 0.25s;

  &:hover {
    border-color: #c8102e;
    color: #c8102e;
  }
}

/* 未找到 */
.not-found {
  text-align: center;
  padding: 80px 0;
  color: #888;

  i {
    font-size: 48px;
    color: #ccc;
    margin-bottom: 20px;
  }

  p {
    font-size: 15px;
    margin-bottom: 24px;
  }
}

/* ===== 响应式 ===== */
@media (max-width: 768px) {
  .recruit-detail-hero {
    height: 240px;
  }

  .recruit-detail-hero-content {
    padding-left: 40px;
  }

  .recruit-detail-hero-content h1 {
    font-size: 32px;
  }

  .hero-en {
    font-size: 14px;
  }

  .contact-tabs {
    gap: 24px;
    padding: 14px 0;
  }

  .recruit-detail-main {
    padding: 40px 0 60px;
  }

  .job-header-top {
    flex-direction: column;
    gap: 16px;
  }

  .job-header-right {
    text-align: left;
  }

  .job-location,
  .job-date {
    justify-content: flex-start;
  }

  .job-header-title {
    font-size: 20px;
  }
}

@media (max-width: 480px) {
  .recruit-detail-hero {
    height: 200px;
  }

  .recruit-detail-hero-content {
    padding-left: 20px;
  }

  .recruit-detail-hero-content h1 {
    font-size: 26px;
  }

  .hero-en {
    font-size: 12px;
    letter-spacing: 2px;
  }

  .contact-tabs {
    gap: 20px;
  }

  .contact-tab-item {
    font-size: 14px;
  }
}
</style>
